import { Pipe, PipeTransform } from '@angular/core';
import { worldCurrencies } from '../catalogs/currencies';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

  transform(currency: string): string | undefined {
    const currencyInfo = worldCurrencies.find(c => c.currency === currency);
    return currencyInfo ? currencyInfo?.symbol : "$";
  }
}
